import React, {useEffect} from 'react';
import {Button, Modal} from '@themesberg/react-bootstrap';
import {FormattedMessage} from 'react-intl';
import {GOOGLE_CONNECTIONS} from '../services/constants';

export default (props) => {
  const {show, onClose} = props;
  const [showGoogleModal, setShowGoogleModal] = React.useState(false);

  useEffect(() => {
    setShowGoogleModal(show);
  }, [show]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setShowGoogleModal(false);
  };

  return (
    <>
      <Modal as={Modal.Dialog} centered show={showGoogleModal} onHide={() => handleClose()}>
        <Modal.Header>
          <Modal.Title className="h6"><FormattedMessage id="UNABLE_TO_SYNC_GOOGLE_CALENDAR"/></Modal.Title>
          <Button variant="close" aria-label="Close" onClick={() => handleClose()}/>
        </Modal.Header>
        <Modal.Body>
          <FormattedMessage id="UNABLE_TO_SYNC_GOOGLE_CALENDAR_MSG" values={{newLine: <br/>}}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="tertiary" className="m-1" onClick={() => window.open(GOOGLE_CONNECTIONS, '_blank')}>
            <FormattedMessage id="MANAGE_GOOGLE_CONNECTIONS"/>
          </Button>
          <Button variant="link" className="text-gray ms-auto" onClick={() => handleClose()}>
            <FormattedMessage id="CLOSE"/>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}